import { isFmbOutstandingBroadcastEnabledForTenant } from "@/utils/fmb-outstanding-broadcast";
import { useTenantFeatureGate } from "./use-tenant-feature-gate";

/**
 * Whether FMB Outstanding broadcast mode is available for the effective tenant
 * (JWT `tenantId`, or `localStorage.impersonatedTenantId` for super-admin).
 */
export function useIsFmbOutstandingBroadcastEnabled(): boolean {
  return useTenantFeatureGate(isFmbOutstandingBroadcastEnabledForTenant);
}
